import { createSlice } from "@reduxjs/toolkit";

import { getProgramData } from "../../services/api/robot";
import { getFromS3URL } from "../../services/api";

import { parsePLCAlarms, getPLCAlarms, getNDaysPLC } from "../../libs/utils";

import { sortBy, flatten } from "lodash";
import moment from "moment";

const alarmSlice = createSlice({
  name: "alarms",
  initialState: {
    fetching: false,
    fetchingError: null,
  },

  reducers: {
    fetchListRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchListFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchListSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
      alarms: action.payload.alarms,
    }),

    fetchRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
      overall: action.payload.alarms,
    }),
  },
});

export const {
  fetchListRequest,
  fetchListFailure,
  fetchListSuccess,
  fetchRequest,
  fetchFailure,
  fetchSuccess,
} = alarmSlice.actions;

export default alarmSlice.reducer;

export const getOverallPLCAlarms = (ids) => async (dispatch) => {
  try {
    dispatch(fetchRequest());

    if (!!ids && ids.length > 0) {
      const overall = await Promise.all(
        ids.map(async (id) => {
          const { data } = await getProgramData(id === "171" ? 1 : id, "plc_alarms");

          const alarms = getNDaysPLC(data);

          if (!!alarms && alarms.length > 0) {
            await Promise.all(
              alarms.map(async (item) => {
                const message = await getFromS3URL(item.url);
                item.message = parsePLCAlarms(message);
              })
            );
          }
          return getPLCAlarms(
            alarms.map(({ message }) => message),
            id
          );
        })
      );

      dispatch(
        fetchSuccess({
          alarms: sortBy(flatten(overall), (item) =>
            moment(item.received_at)
          ).reverse(),
        })
      );
    }
  } catch (err) {
    dispatch(fetchFailure(err.toString()));
  }
};

/**
 * getRobotPLCAlarms
 * 1. Fetch the list of latest PLC alarm files
 * 2. List the last 30 days from fileName
 * 3. Loop to get PLC alarms from each fileName
 * 4. Make it adaptable for future change which removes 1-3 steps
 */
export const getRobotPLCAlarms = (id) => async (dispatch) => {
  try {
    dispatch(fetchListRequest());

    const { data } = await getProgramData(id === "171" ? 1 : id, "plc_alarms");

    const alarms = getNDaysPLC(data);

    if (!!alarms && alarms.length > 0) {
      await Promise.all(
        alarms.map(async (item, index) => {
          const message = await getFromS3URL(item.url);
          item.message = parsePLCAlarms(message);
        })
      );
    }

    dispatch(
      fetchListSuccess({
        alarms: getPLCAlarms(
          alarms.map(({ message }) => message),
          id
        ),
      })
    );
  } catch (err) {
    dispatch(fetchListFailure(err.toString()));
  }
};
